export default "__VITE_ASSET__CWNqsBxt__"